import escapeNonLatin1 from "Common/componentUtils/escapeNonLatin1";
import escapeUnicodeSurrogatePair from "Common/componentUtils/escapeUnicodeSurrogatePair";
import { getReactElementSize } from "Common/componentUtils/reactElementSize";
import head from "lodash/head";
import replace from "lodash/replace";
import split from "lodash/split";
import imgSrcToBase64 from "./imgSrcToBase64";
export default async (label, extraSpace, abortController, mimeType = "image/png") => {
    const { height: calculatedHeight, width: calculatedWidth, staticMarkup } = await getReactElementSize(label, true);
    if (!staticMarkup)
        return null;
    if (abortController === null || abortController === void 0 ? void 0 : abortController.signal.aborted)
        return null;
    const prefix = head(split(staticMarkup, /\s/));
    let innerMarkup = prefix
        ? replace(staticMarkup, new RegExp(`^${prefix}`), `${prefix} xmlns="http://www.w3.org/1999/xhtml"`)
        : staticMarkup;
    innerMarkup = replace(innerMarkup, /(\S)\/>/g, "$1 />");
    const svgWidth = calculatedWidth + ((extraSpace === null || extraSpace === void 0 ? void 0 : extraSpace.w) || 0);
    const svgHeight = calculatedHeight + ((extraSpace === null || extraSpace === void 0 ? void 0 : extraSpace.h) || 0);
    const svgString = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" ` +
        `width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${svgWidth} ${svgHeight}">` +
        `<foreignObject x="0" y="0" width="100%" height="100%">${innerMarkup}</foreignObject></svg>`;
    const base64 = `data:image/svg+xml;base64,${window.btoa(escapeNonLatin1(escapeUnicodeSurrogatePair(svgString)))}`;
    return mimeType !== "image/svg+xml"
        ? imgSrcToBase64(base64, svgWidth, svgHeight, mimeType, abortController)
        : base64;
};
